import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import LeanFormView from '../views/LeanFormView.vue';
import LeanListView from '../views/LeanListView.vue';
import LeanChangePassword from '../components/LeanChangePassword.vue';
import LeanAdminUserList from '../components/LeanAdminUserList.vue';
import LeanAdminUserForm from '../components/LeanAdminUserForm.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/account/change-password',
    component: LeanChangePassword
  },
  {
    path: '/admin/users',
    component: LeanAdminUserList
  },
  {
    path: '/admin/users/_new',
    component: LeanAdminUserForm,
    props: (route) => ({ name: '', isNew: true })
  },
  {
    path: '/admin/users/:name',
    component: LeanAdminUserForm,
    props: (route) => ({ name: route.params.name })
  },
  {
    path: '/data/:datatype',
    component: LeanListView,
    props: (route) => ({ datatype: route.params.datatype })
  },
  {
    path: '/data/:datatype/_new',
    component: LeanFormView,
    props: (route) => ({ datatype: route.params.datatype, slug: '', isNew: true })
  },
  {
    path: '/data/:datatype/:slug',
    component: LeanFormView,
    props: (route) => ({ datatype: route.params.datatype, slug: route.params.slug })
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
